import React from 'react';
import {
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Tooltip
} from '@material-ui/core';
import { API_URL } from '../../constants/api';
import CancelIcon from '@material-ui/icons/Cancel';
import EditIcon from '@material-ui/icons/Edit';
import { apiBatchRequest, apiPost, apiRequest } from '../../utils/api_service';
import SaveIcon from '@material-ui/icons/Save';
import { ShowToast, toastType } from '../../utils/toast-service';
import {
  getCurrentPayCycleStartDate,
  getDistinctByProperty,
  isGridFormValid,
  IsSectionVisible,
  UpdateColumnWithConfiguration
} from '../../utils/helper';
import GridTable from '../common/Table/Table';
import { DateFormat, SECTIONS } from '../../constants/appConstants';
import { arCenterializedPropertyMappingColumn } from '../../constants/MockData';
import _ from 'lodash';
import DeleteIcon from '@material-ui/icons/Delete';
import ConfirmDialog from '../common/Dailogbox/confirmDailog';
import moment from 'moment';

// Component to map AR admins to the Properties
class ConfigurationARAdminPropertyMapping extends React.Component {
  // Constructor to set initial state of component
  constructor(props) {
    super(props);
    this.state = {
      arPropertyMappingData: [],
      isInAddMode: false,
      propertyMasterData: [],
      configuration: [],
      employeeMasterData: [],
      selectedEditRowId: undefined,
      updateData: {
        userEmail: null,
        marketId: null,
        marketName: null,
        employeeId: null,
        reimbursementAmountAccess: false,
        billingAdjustmentAccess: false
      },
      arCenterializedPropertyMappingCol: _.clone(arCenterializedPropertyMappingColumn),
      isDelete: false,
      showWarningMessage: false,
      confirmMessage: '',
      openAdminChangeConfirmDialog: false,
      adminChangeConfirmMessage: ''
    };
  }

  // Get API data before components are mounted
  componentDidMount() {
    this.getMasterData();
  }

  // Get Master data from DB using API calls
  getMasterData = () => {
    const params = {
      allocationStartDate: moment(getCurrentPayCycleStartDate()).format(DateFormat),
      billingStartDate: moment(getCurrentPayCycleStartDate()).format(DateFormat),
      isAccessOverride: true
    };

    this._asyncRequest = apiBatchRequest([
      {
        url: API_URL.Employee.GetEmployeeMasterData + '?showInActive=true&departmentId=' + 30,
        key: 'employeeMasterData'
      },
      {
        url: API_URL.Property.GetPropertyLegalEntity,
        key: 'propertyMasterData',
        params: params
      }
    ])
      .then(({ employeeMasterData, propertyMasterData }) => {
        this._asyncRequest = null;
        if (employeeMasterData.success !== true) {
          ShowToast('Something went wrong', toastType.ERROR, 5000, 500, 'Server error');
          return;
        }

        propertyMasterData.data = (propertyMasterData.data || []).filter(x =>
          (x.serviceTypeId || '').split('|').indexOf(('3' || '').toString()) !== -1);

        this.setState({
          propertyMasterData: getDistinctByProperty(propertyMasterData.data || [], 'propertyName'),
          employeeMasterData: employeeMasterData.data || []
        }, () => {
          this.GetARAdminPropertyMapping();
        });
      })
      .catch(() => {
        this._asyncRequest = null;
      });
  };

  // Get Properties with AR Admin mapping details
  GetARAdminPropertyMapping = () => {
    this._asyncRequest = apiBatchRequest([
      {
        url: API_URL.Users.GetARAdminPropertyMapping,
        key: 'arPropertyMappingData'
      }
    ])
      .then(({ arPropertyMappingData }) => {
        this.setState({
          arPropertyMappingData: arPropertyMappingData.data || [],
          configuration: arPropertyMappingData.config || []

        });
      });
  };

  // Handle cancel event
  cancelMode = () => {
    this.setState({ selectedEditRowId: undefined, isInAddMode: false, updateData: undefined });
  };

  // Check validations
  isValidForm = () => {
    let IsValid = true;
    const { updateData, arCenterializedPropertyMappingCol } = this.state;
    arCenterializedPropertyMappingCol.forEach((ele) => {
      isGridFormValid(updateData[ele.key], ele, updateData);
      if (ele.isInErrorState === true) {
        IsValid = false;
      }
    });
    this.setState({ arCenterializedPropertyMappingCol }, this.forceUpdate());
    return IsValid;
  };

  // Check if mapping is already exists
  isEmployeeExists = () => {
    const newParam = this.state.updateData;
    const recordExist = this.state.arPropertyMappingData.find(x => x.employeeId === newParam.employeeId && x.arPropertyMappingId !== newParam.arPropertyMappingId);
    return recordExist !== undefined;
  }

  // save updated mapping data
  saveUpdatedRecord = () => {
    const newParam = this.state.updateData;
    if (!this.isValidForm()) { return false; }
    if (this.isEmployeeExists() === true) {
      ShowToast('Employee: ' + newParam.employeeName + ' is already present. Please edit the same record.', toastType.ERROR, 5000, 500);
    } else {
      const params = {
        employeeId: newParam.employeeId,
        propertyId: newParam.propertyId
      };
      this.UpdateARAdminPropertyMapping(params);
    };
  }

  // Save AR Admin - Property mapping data into database
  UpdateARAdminPropertyMapping = (params) => {
    apiPost({
      url: API_URL.Users.UpdateARAdminPropertyMapping,
      params: {},
      postBody: params
    }).then(({ data: response }) => {
      if (response.success === true) {
        ShowToast(this.state.isInAddMode ? 'Record added successfully.' : 'Record updated successfully.', toastType.SUCCESS, 5000, 500);
        this.setState({
          updateData: undefined,
          selectedEditRowId: undefined,
          isInAddMode: false,
          showWarningMessage: false,
          confirmMessage: ''
        }, () => this.GetARAdminPropertyMapping());
      } else {
        ShowToast(response.errorMessage, toastType.ERROR, 5000, 500);
      }
    });
  };

  // Render action buttons for the record
  renderActionColumn = (cellInfo) => {
    return (
      <>
        {this.state.selectedEditRowId !== undefined && cellInfo.arPropertyMappingId === this.state.selectedEditRowId.value
          ? (
            <>
              <Tooltip title="Save Record">
                <IconButton aria-label={'refreshData'} size="small" onClick={() => { }}>
                  <SaveIcon fontSize="small" size="small" onClick={this.saveUpdatedRecord} />
                </IconButton>
              </Tooltip>
              <Tooltip title="Cancel">
                <IconButton aria-label={'refreshData'} size="small" onClick={this.cancelMode}>
                  <CancelIcon fontSize="small" size="small" />
                </IconButton>
              </Tooltip>
            </>
          )
          : <>{(IsSectionVisible(SECTIONS.CONFIGURATION, SECTIONS.CENTERALIZED_AR_ADMIN_PROPERTY_MAPPING, SECTIONS.ADD_EDIT)) &&
            (<>
              <Tooltip title="Edit Record">
                <IconButton
                  aria-label={'refreshData'}
                  size="small"
                  onClick={() => {
                    this.setState({ selectedEditRowId: { key: 'arPropertyMappingId', value: cellInfo.arPropertyMappingId }, isInAddMode: false, updateData: { ...cellInfo } });
                  }}
                >
                  <EditIcon fontSize="small" size="small" />
                </IconButton>
              </Tooltip>
              <Tooltip title="Delete">
                <IconButton aria-label={'refreshData'} size="small" onClick={() => {
                  this.deleteRecord(cellInfo);
                }}
                >
                  <DeleteIcon fontSize="small" size="small" />
                </IconButton>
              </Tooltip></>
            )}
          </>
        }
      </>
    );
  };

  /**
 * delete record
 */
  deleteRecord(cellInfo) {
    this.setState({
      showWarningMessage: true,
      confirmMessage: 'Do you want to delete this record ?',
      updateData: cellInfo
    });
  };

  /**
 * handle dialog box click event
 * @param {*} e
 */
  onClickHandle(e) {
    if (e) {
      const newParam = this.state.updateData;
      const params = {
        employeeId: newParam.employeeId,
        propertyId: newParam.propertyId,
        isDelete: true
      };
      this.UpdateARAdminPropertyMapping(params);
    } else {
      this.setState({
        showWarningMessage: false,
        confirmMessage: ''
      });
    }
  }

  // Handle confirm event on confirmation dialog box
  onConfirmAdminChange(e) {
    if (e) {
      const { changeObj, propertyMasterData, arCenterializedPropertyMappingCol } = this.state;
      const param = { ...this.state.updateData };
      const valueOfProperty = [];
      changeObj?.value?.forEach(val => {
        propertyMasterData.find((x) => x.propertyName === val) &&
          valueOfProperty.push(propertyMasterData.find((x) => x.propertyName === val).propertyId);
      });
      param.propertyId = valueOfProperty.join('|');
      param[changeObj.fieldName] = changeObj?.value?.join('|');
      isGridFormValid(changeObj?.value, arCenterializedPropertyMappingCol.find(x => x.key === changeObj?.fieldName), param);

      this.setState({ updateData: param, openAdminChangeConfirmDialog: false, adminChangeConfirmMessage: '', changeObj: null, arCenterializedPropertyMappingCol }, () => {
        this.forceUpdate();
      });
    } else {
      this.setState({
        openAdminChangeConfirmDialog: false,
        adminChangeConfirmMessage: '',
        changeObj: null
      });
    }
  }

  // Handle change event of values in table
  handleTableEditChange = (value, fieldName, row, addMode) => {
    const { propertyMasterData, arCenterializedPropertyMappingCol, employeeMasterData, arPropertyMappingData } = this.state;
    const param = { ...this.state.updateData };

    if (fieldName === 'propertyName') {
      const assignedProperties = row.propertyName?.split('|') || [];
      const selectedProperty = value.filter(x => {
        let arr = assignedProperties.filter(y => y === x);
        return (arr.length === 0);
      }) || [];

      if (selectedProperty?.length > 0 &&
        (arPropertyMappingData.filter(x =>
          (x.propertyName?.split('|') || []).filter(y => y === selectedProperty[0]).length > 0).length > 0
        )) {
        const currentAdmin = arPropertyMappingData.find(x =>
          (x.propertyName?.split('|') || []).find(y => y === selectedProperty[0])
        )?.employeeName;
        const msg = currentAdmin + ' is already assigned as a AR Admin to the property ' + selectedProperty[0] + '. Do you want to change the AR Admin as ' + row.employeeName + '?';
        this.setState({ openAdminChangeConfirmDialog: true, adminChangeConfirmMessage: msg, changeObj: { value: value, fieldName: fieldName, row: row } });
        return;
      } else {
        const valueOfProperty = [];
        value.forEach(val => {
          propertyMasterData.find((x) => x.propertyName === val) &&
            valueOfProperty.push(propertyMasterData.find((x) => x.propertyName === val).propertyId);
        });
        param.propertyId = valueOfProperty.join('|');
        param[fieldName] = value.join('|');
      }
    } else if (fieldName === 'employeeName' && value !== null) {
      const valueOfEmployee = employeeMasterData.find((x) => x.employeeName === value);
      param.employeeId = (valueOfEmployee || {}).employeeId;
      param[fieldName] = value.trim();
    } else {
      param[fieldName] = value;
    }
    isGridFormValid(value, arCenterializedPropertyMappingCol.find(x => x.key === fieldName), param);

    this.setState({ updateData: param, arCenterializedPropertyMappingCol }, () => {
      this.forceUpdate();
    });
  };

  // Add new record
  AddNewRecord = () => {
    if (this.state.isInAddMode === true) {
      ShowToast('You can add one row at a time!', toastType.WARNING, 5000, 500);
      return false;
    }

    const rowNew = {
      propertyId: null,
      propertyName: null,
      employeeId: null,
      employeeName: null,
      arPropertyMappingId: 0
    };
    this.setState({ isInAddMode: true, selectedEditRowId: { key: 'arPropertyMappingId', value: 0 }, updateData: rowNew, arCenterializedPropertyMappingCol: _.cloneDeep(arCenterializedPropertyMappingColumn) });
  };

  // Render components based on conditions
  render() {
    const { arPropertyMappingData, employeeMasterData, configuration, propertyMasterData, isInAddMode, selectedEditRowId, updateData, arCenterializedPropertyMappingCol } = this.state;
    const EditSource = [];
    EditSource.push(
      { key: 'employeeMasterData', data: (employeeMasterData || []).filter(x => x.employeeStatus === true) },
      { key: 'propertyMasterData', data: propertyMasterData }
    );
    return (
      <>
        {this.state.showWarningMessage && (
          <ConfirmDialog
            IsOpen={this.state.showWarningMessage}
            Message={this.state.confirmMessage}
            OnHandelClick={(isValid) => { this.onClickHandle(isValid); }}
            AgreeText="Yes"
            DisAgreeText="No"
          ></ConfirmDialog>
        )}
        {this.state.openAdminChangeConfirmDialog && (
          <ConfirmDialog
            IsOpen={this.state.openAdminChangeConfirmDialog}
            Message={this.state.adminChangeConfirmMessage}
            OnHandelClick={(isValid) => { this.onConfirmAdminChange(isValid); }}
            AgreeText="Yes"
            DisAgreeText="No"
          ></ConfirmDialog>
        )}
        <Table
          aria-labelledby="tableMenuTitle"
          size={'small'}
          aria-label="configuration table"
        >
          <TableHead>
            <TableRow>
              <TableCell
                key={'configureHeader'}
                className="content-header"
                colSpan={2}
              >
                <div className="content-header d-flex">
                  {' '}
                  <div
                    className="col-xs-11"
                    style={{ display: 'inline-block', alignItems: 'center' }}
                  >
                    Configure AR Admin Property Mapping
                                    </div>
                </div>
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            <TableRow>
              <TableCell>
                <GridTable
                  columns={UpdateColumnWithConfiguration(arCenterializedPropertyMappingCol, configuration, [])}
                  data={arPropertyMappingData}
                  config={arCenterializedPropertyMappingCol}
                  renderActionColumn={this.renderActionColumn}
                  selectedEditRowId={selectedEditRowId}
                  isInAddMode={isInAddMode}
                  EditSource={EditSource}
                  handleTableEditChange={this.handleTableEditChange}
                  updateData={updateData}
                  isInline={true}
                  AddNewRecord={{ action: this.AddNewRecord, title: 'Add New AR Admin Property Mapping', visible: IsSectionVisible(SECTIONS.CONFIGURATION, SECTIONS.CENTERALIZED_AR_ADMIN_PROPERTY_MAPPING, SECTIONS.ADD_EDIT) }}
                ></GridTable>
              </TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </>
    );
  };
}

export default ConfigurationARAdminPropertyMapping;
